import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '@app/core/services/data.service';
import { BaseComponent } from '../base/base.component';

@Component({
    selector: 'app-record-base-item',
    templateUrl: './record-base-item.component.html',
    styleUrls: ['./record-base-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RecordBaseItemComponent extends BaseComponent implements OnInit {

  protected pageTitle = 'SystemAdmin.PageTitles.Dashboard';

  @Input()
  public recordBase: any;
  constructor(public dataService: DataService) {
    super();
  }

  ngOnInit(): void {
  }

}
